<template>
  <div>
    <header class="navbar navbar-header navbar-header-fixed">
      <div class="navbar-brand">
        <a href="/" class="df-logo">Гарын<span>авлага</span></a>
      </div>
      <!-- navbar-brand -->
      <div class="navbar-right">
        <a href="http://vetdrug.mn/#/login" target="_blank" class="btn btn-buy">
          <feather type="log-in"></feather>
          <span>Системд нэвтрэх</span>
        </a>
      </div>
      <!-- navbar-right -->
    </header>
    <!-- navbar -->

    <vue-custom-scrollbar
      id="sidebarMenu"
      class="sidebar sidebar-fixed sidebar-components"
      style="height: calc(100vh - 109px); width: 20%"
    >
      <div class="sidebar-header">
        <a href="" id="mainMenuOpen"><feather type="menu"></feather></a>
        <h5>Components</h5>
        <a href="" id="sidebarMenuClose"><feather type="x"></feather></a>
      </div>
      <!-- sidebar-header -->
      <div class="sidebar-body">
        <ul class="sidebar-nav" :key="allKey">
          <li class="nav-label mg-b-15">Үндсэн цэс</li>
          <li
            class="nav-item"
            v-for="(c, i) in help_category"
            :key="i"
            :class="{ show: help_category_active == c.id }"
          >
            <a
              @click="loadCategory(c.id, true)"
              role="button"
              class="nav-link with-sub"
              :class="{ active: help_category_active == c.id }"
            >
              <feather type="layers"></feather> {{ c.title }}
            </a>
            <nav class="nav">
              <a
                @click="loadTask(t.id)"
                role="button"
                :class="{ active: taskCur.id == t.id }"
                v-for="(t, ti) in tasks_cur"
                :key="ti"
                >{{ t.task }}</a
              >
            </nav>
          </li>
        </ul>
      </div>
    </vue-custom-scrollbar>
    <div class="section-nav vid-here" style="width: 30%; padding: 20px">
      <div v-html="taskCur.taskDescEn"></div>
    </div>
    <div
      class="content content-components"
      style="margin-left: 20%; margin-right: 30%"
    >
      <div class="container" style="min-height: calc(100vh - 200px)">
        <h1 class="df-title">{{ taskCur.task }}</h1>
        <div class="help-desk" v-html="taskCur.taskDesc"></div>
      </div>
    </div>
  </div>
</template>

<style>
html {
  overflow: auto !important;
}
.vid-here iframe {
  width: 100%;
}
.help-desk img {
  max-width: 100%;
}
</style>

<script>
import { request } from "@/api/all";
import vueCustomScrollbar from "vue-custom-scrollbar";
var _ = require("lodash");

import { mapActions } from "vuex";

export default {
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      allKey: 0,
      params: {
        cid: 0,
        iod: 0
      },
      help_category: [],
      help_category_active: 0,
      tasks_all: [],
      tasks_cur: [],
      taskCur: {
        id: 0,
        task: "",
        taskDesc: ""
      }
    };
  },
  mounted() {
    require("@/assets/scss/pages/demo.scss");
    //this.featherReplace();
    this.params = this.$route.params;
    this.loadTasks();
  },
  // updated(){
  //   this.featherReplace();
  // },
  methods: {
    ...mapActions(["handleLoading"]),
    initNewsCategory() {
      request({
        api: { method: "GET", url: "Type/GetTreeData" },
        params: { parentId: 0, key: "userManualMenu" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.handleLoading({ isLoading: false });
          this.help_category = res.data.types;
          if (res.data.types.length) {
            let _cid = parseInt(this.params.cid, 10);
            if (_cid > 0) {
              this.loadCategory(_cid);
            } else {
              this.loadCategory(res.data.types[0].id);
            }
          }
        }
      });
    },
    loadTasks() {
      this.handleLoading({ isLoading: true });
      //api: { method: "POST", url: "TaskCore/GetCoreList" },
      request({
        api: { method: "POST", url: "task/getDataWDI" },
        data: {
          ot: 492,
          skip: 0,
          size: 200,
          projectId: 53800,
          model: {
            isPublic: true
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.tasks_all = _.orderBy(res.data.tasks, "ord", "asc");
          this.initNewsCategory();
        }
      });
    },
    loadCategory(cid, force) {
      if (this.help_category_active == cid) {
        this.help_category_active = 0;
      } else this.help_category_active = cid;

      //console.log(this.help_category_active);
      this.tasks_cur = this.tasks_all.filter(x => x.locTypeId == cid);
      this.$nextTick(() => {
        this.allKey++;
      });

      this.taskCur = {
        id: 0,
        task: "",
        taskDesc: ""
      };

      if (force != undefined && force) {
        if (this.tasks_cur.length > 0) {
          this.loadTask(this.tasks_cur[0].id);
        }
      } else {
        let _id = parseInt(this.params.id, 10);
        if (_id > 0) {
          this.loadTask(_id);
        } else if (this.tasks_cur.length > 0) {
          this.loadTask(this.tasks_cur[0].id);
        }
      }
    },
    loadTask(id) {
      if (id != parseInt(this.params.id, 10)) {
        this.$router.push({
          name: "",
          params: { cid: this.help_category_active, id: id }
        });
      }
      //console.log(id);
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.taskCur = res.data.task;
        }
      });
    }
  }
};
</script>
